import React from 'react';
import pettt from '../assets/pettt.png';

const AboutUs = () => {
  return (
    <div className="bg-[#f9eae3] h-full pb-10 pt-6 flex items-center justify-center mt-32 px-[3%] md:px-[5%] lg:px-[10%]">
      <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between max-w-7xl w-full">
        <div className="flex-1 mb-8 md:mb-0 w-full md:w-1/2 px-4">
          <h2 className="text-3xl font-semibold text-[#551E19] bg-[#E6B17E] py-2 px-6 inline-block rounded-full mb-6">
            About Us
          </h2>
          <p className="text-sm md:text-lg text-gray-800 font-montserrat leading-relaxed mb-8 text-justify md:text-start">
            At Poo Poo Shop, we believe every pet deserves the best. That’s why we offer a curated collection 
            of high-quality accessories that blend comfort, style, and functionality. Whether it’s for playtime, 
            nap time, or walks, we’ve got something for every pet.
          </p>
          <div className="space-y-6">
            <ProgressBar label="Top-Quality Products" percentage={95} />
            <ProgressBar label="Cash on Delivery" percentage={80} />
            <ProgressBar label="Customer Happiness Guaranteed" percentage={99} />
          </div>
        </div>
        <div className="w-full md:w-1/2 px-4">
          <img 
            src={pettt} 
            alt="Pet" 
            className="hidden md:flex w-full h-auto md:w-[600px] md:h-[520px] lg:w-[700px] lg:h-[603px] object-cover rounded-lg lg:-mt-40" 
          />
        </div>
      </div>
    </div>
  );
};

const ProgressBar = ({ label, percentage }) => {
  return (
    <div>
      <p className="text-lg text-[#b0835e] font-medium mb-1">{label}</p>
      <div className="w-full bg-white rounded-full h-3">
        <div
          className="bg-[#5d3527] h-3 rounded-full"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default AboutUs;
